// 通知类型定义
export interface Notification {
  notificationId?: number
  senderUserId?: number
  receiverUserId?: number
  type?: number
  targetType?: number
  targetId?: number
  content?: string
  status?: number
  createTime?: string
  pageNum?: number
  pageSize?: number
  nickName?: string
  fromUserNickName?: string
  fromUserAvatar?: string
}

// 通知类型常量
export const NotificationType = {
  COMMENT: 1,    // 评论
  REPLY: 2,      // 回复
  LIKE: 3,       // 点赞
  APPROVE: 4,    // 审核通过
  REJECT: 5      // 审核失败
} as const

// 目标类型常量
export const TargetType = {
  POST: 1,       // 帖子
  COMMENT: 2,    // 评论
  REPLY: 3       // 回复
} as const

// 通知状态常量
export const NotificationStatus = {
  UNREAD: 0,     // 未读
  READ: 1        // 已读
} as const 